export default __webpack_public_path__ + "static/media/search.dff238e0.svg";